import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import styles from "../studioInfoModule.module.css";
import ReactTooltip from "react-tooltip";

function content(props) {
  return (
    <>
    <div className={`${styles.callout} ${styles.calloutLight}`}  data-tip={props.data.tooltip} data-for={props.data.title}>
      <p>{props.data.title}</p>
      <p className={`${styles.calloutValue}`}>{(props.data.current * 100).toFixed(2)}%</p>
    </div>
      <ReactTooltip id={props.data.title} html />
    </>
  );
}

export default connect(state => ({
  data: state.studioInfo.attritionRate.data
}))(content);

content.propTypes = {
  data: PropTypes.object.isRequired
};
